import * as React from 'react';
export const arbitrumSvg = React.forwardRef(function arbitrumSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.297 11.298v9.415c0 .597.315 1.155.831 1.45l8.041 4.705a1.63 1.63 0 0 0 1.656 0l8.047-4.704c.51-.302.83-.854.83-1.451v-9.415c0-.597-.314-1.154-.83-1.456l-8.047-4.704a1.63 1.63 0 0 0-1.656 0L7.123 9.842a1.698 1.698 0 0 0-.826 1.456Z',
      fill: '#213147',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm17.758 17.829-1.152 3.186a.381.381 0 0 0 0 .273l1.971 5.483 2.286-1.337-2.74-7.61a.193.193 0 0 0-.366.005Zm2.296-5.364a.195.195 0 0 0-.37 0l-1.152 3.185a.382.382 0 0 0 0 .273l3.235 8.982 2.285-1.336-3.998-11.104Z',
      fill: '#12AAFF',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 5.485c.056 0 .112.017.163.045l8.703 5.091a.324.324 0 0 1 .163.285v10.182c0 .12-.062.228-.163.285l-8.703 5.097a.335.335 0 0 1-.163.045.335.335 0 0 1-.163-.045l-8.703-5.091a.324.324 0 0 1-.163-.285V10.906c0-.12.062-.228.163-.285l8.703-5.09A.335.335 0 0 1 16 5.484ZM16 4c-.309 0-.623.085-.898.245l-8.704 5.09a1.83 1.83 0 0 0-.898 1.57v10.183c0 .649.343 1.252.898 1.576l8.704 5.091c.275.165.584.245.898.245.314 0 .623-.085.898-.245l8.704-5.09c.555-.325.898-.922.898-1.577V10.906c0-.649-.343-1.252-.898-1.576l-8.704-5.085C16.618 4.085 16.308 4 16 4Z',
      fill: '#9DCCED',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm10.245 24.917.803-2.219 1.605 1.354-1.499 1.394-.91-.53Z',
      fill: '#213147',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.264 10.184h-2.206a.394.394 0 0 0-.37.261l-4.729 13.14 2.286 1.337 5.21-14.471a.201.201 0 0 0-.19-.268Zm3.864 0H16.92a.394.394 0 0 0-.37.261l-5.397 15 2.286 1.338 5.873-16.332a.198.198 0 0 0-.185-.268Z',
      fill: '#fff',
    }),
  );
});
arbitrumSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arbitrum = {
  category: 'brand',
  colorable: false,
  name: 'arbitrum',
  svg: arbitrumSvg,
};
